// src/App.js
import React from 'react';
import { BrowserRouter, Routes, Route, useLocation, useMatch } from 'react-router-dom';
import Terminal from './components/Terminal';
import TokenSite from './pages/TokenSite';
import TokenHistory from './components/TokenHistory';
import Navigation from './components/Navigation';
import AboutKyora from './components/AboutKyora';
import RoadMap from './components/RoadMap';

// Placeholder components for new routes
const About = () => (
  <div className="min-h-screen pt-20 px-4">
    <div className="max-w-7xl mx-auto">
      <div className="border border-blue-500/30 rounded-lg bg-black/90 p-6">
        <h1 className="text-3xl font-bold text-blue-200 mb-4">About Kyora AI</h1>
        <p className="text-blue-200">Advanced AI system for token creation and management.</p>
      </div>
    </div>
  </div>
);

// New component to handle conditional Navigation
const MainApp = () => {
  const location = useLocation();
  const match = useMatch("/:tokenName");

  // Define paths that should **not** be considered as TokenSite routes
  const excludedPaths = ['about', 'roadmap', 'token-history'];

  // Determine if the current path is a TokenSite route
  const isTokenPath = match && !excludedPaths.includes(match.params.tokenName);

  return (
    <div className="relative min-h-screen bg-gradient-to-b from-gray-900 to-black">
      {/* Conditionally render Navigation */}
      {!isTokenPath && <Navigation />}

      {/* Adjust height based on Navigation presence */}
      <main className={`relative ${!isTokenPath ? 'h-[calc(100vh-56px)] sm:h-[calc(100vh-64px)]' : 'h-screen'}`}>
        <Routes>
          {/* Main terminal route */}
          <Route
            path="/"
            element={
              <div className="h-full">
                <Terminal />
              </div>
            }
          />

          {/* Token history routes - both list and detail */}
          <Route
            path="/token-history"
            element={
              <div className="h-full">
                <TokenHistory />
              </div>
            }
          />
          <Route
            path="/token-history/:tokenId"
            element={
              <div className="h-full">
                <TokenHistory />
              </div>
            }
          />

          {/* New routes */}
          <Route path="/about" element={<AboutKyora />} />
          <Route path="/roadmap" element={<RoadMap />} />

          {/* Token site routes - fallback for direct paths */}
          <Route path="/:tokenName" element={<TokenSite />} />
        </Routes>
      </main>
    </div>
  );
};

function App() {
  // Add this helper
  const formatTokenName = (name) => {
    return name.toLowerCase().replace(/\s+/g, '-');
  };

  const host = window.location.host;
  const hostParts = host.split('.');
  // Consider www as main domain, not subdomain

  const isSubdomain = hostParts.length > 2 && hostParts[0] !== 'www';
  const subdomain = isSubdomain ? formatTokenName(hostParts[0]) : null;

  if (isSubdomain) {
    return (
      <BrowserRouter>
        <Routes>
          <Route
            path="*"
            element={
              <div className="relative min-h-screen bg-gradient-to-b from-gray-900 to-black">
                <TokenSite tokenName={subdomain} />
              </div>
            }
          />
        </Routes>
      </BrowserRouter>
    );
  }

  return (
    <BrowserRouter>
      <MainApp />
    </BrowserRouter>
  );
}

export default App;